import Vue from 'vue'
import App from './App.vue'

// Vue Router
import VueRouter from 'vue-router'

// FullPage.js
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'

// Particles.js
import VueParticles from 'vue-particles'


// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faGithub, faLinkedinIn, faCodepen  } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faArrowDown,
    faArrowLeft,
    faEnvelope,
    faGithub,
    faLinkedinIn,
    faCodepen
    )

Vue.component('fa-icon', FontAwesomeIcon)

Vue.prototype.$VUE_APP_API_URL = process.env.VUE_APP_API_URL

Vue.use(VueRouter)
Vue.use(VueFullPage)
Vue.use(VueParticles)
Vue.config.productionTip = false

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/projects/:slug",
            components: require("./components/Project.vue"),
        },
        {
            path: "/about",
            components: require("./components/About.vue"),
        },
    ],
});

new Vue({
    router,
    render: h => h(App)
}).$mount("#app")